// Two different demos, deliberately:
//
// DEMO_STORE_URL — the real Cady Shopify storefront, so a merchant sees Garu
// running inside a live Shopify theme rather than anything we control.
//
// GARU_DEMO_URL — our own demo store (pages/DemoStore.tsx), which mounts the
// byte-identical widget asset a merchant installs. Lives at demo.garu.ai; the
// old www /demo-store URLs 307 there.
//
// Every call site opens DEMO_STORE_URL in a new tab (target="_blank"); the
// Garu demo is a first-party destination and navigates in place.
export const DEMO_STORE_URL = 'https://cady-store-8672.myshopify.com';
export const GARU_DEMO_URL = 'https://demo.garu.ai';
